import { EmployeeDetail } from "./../../../components/Pages/Catalogs/Employee/EmployeeDetail";
import { CreateEmployeeDto } from "../../../dtos/catalogs/employee/CreateEmployeeDto";
import { EmployeeService } from "../../../services/catalogs/EmployeeService";
import React from "react";
import { IAppEntity } from "../../entities";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { NFLookupEmployee } from "../../../components/Shared/NewForms/NFLookupEmployee";
import EmployeeList from "../../../components/Pages/Catalogs/Employee/EmployeeList";

export const Employee: IAppEntity = {
  entityType: "catalog",
  title: "Employee",
  pluralTitle: "Employees",
  apiUrl: "Employees",
  apiEnum: ReferenceTypes.CatalogEmployee,
  getDetailViewComponent(
    model: any,
    modelUpdatedEvent: (model: any) => void
  ): any {
    return React.createElement(EmployeeDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    });
  },
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(EmployeeList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupEmployee, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService() {
    return new EmployeeService(this.apiUrl);
  },
  getEmptyModel(): CreateEmployeeDto {
    return {
      name: "",
      companyInsurance: 0,
      companySalary: 0,
      divisionId: "",
      personId: "",
      companyId: "",
      hireDate: new Date(),
      departureDate: new Date(),
      dateOfBirth: new Date(),
      tin: "",
      lastName: "",
      firstName: "",
    };
  },
};
